<div class="flex-container">
  <div class="container">
    <div class="f-row">
      <section class="section-wrapper">
        <div class="f-col">
          <h2 class="genric-comp-heading">Frequently Asked Questions</h2>
          <div class="genric-custom-search">
            <mat-form-field class="customsearch-matinput">
                <mat-icon fontSet="material-symbols-outlined" matSuffix class="search-icon">search</mat-icon>
                <input type="text" matInput maxlength="35" placeholder="Search keywords, support & more...">
            </mat-form-field>
          </div>
        </div>

        <div class="section-context">
          <div class="menu-left-content">
            <ul class="menu-listing">
              <li class="active">
                <a href="#">
                  <span>Popular FAQs</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>

              <li>
                <a href="#">
                  <span>Covid-19 related assistance</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Booking</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Baggage</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Seats</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Transit eVisa</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Check-in</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Alfursan</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Website</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Refund</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Complaints</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Others</span>
                  <span class="right-icon">
                    <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div class="f-col right-content">
            <div class="section-heading">
                <h2 class="h2-heading">Popular FAQs</h2>
            </div>

            <div class="f-col login-brief-container">
                <mat-accordion class="mat-accordion faq__accordion">
                  <mat-expansion-panel (opened)="onExpand('Lorem ipsum dolor sit amet ?_'+expandQues)" (closed)="onCollapse('Lorem ipsum dolor sit amet ?_'+collapseQues)">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Lorem ipsum dolor sit amet ? </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="mat-panel-body-custom ng-star-inserted">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate risus mattis ornare at egestas tortor.
                      </p>
                    </div>
                  </mat-expansion-panel>
            
                  <mat-expansion-panel (opened)="onExpand('Lorem ipsum dolor sit amet ?_'+expandQues)" (closed)="onCollapse('Lorem ipsum dolor sit amet ?_'+collapseQues)">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Lorem ipsum dolor sit amet ? </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="mat-panel-body-custom ng-star-inserted">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate risus mattis ornare at egestas tortor.
                      </p>
                    </div>
                  </mat-expansion-panel>
            
                  <mat-expansion-panel (opened)="onExpand('Lorem ipsum dolor sit amet ?_'+expandQues)" (closed)="onCollapse('Lorem ipsum dolor sit amet ?_'+collapseQues)">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Lorem ipsum dolor sit amet ? </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="mat-panel-body-custom ng-star-inserted">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate risus mattis ornare at egestas tortor.
                      </p>
                    </div>
                  </mat-expansion-panel>
            
                  <mat-expansion-panel (opened)="onExpand('Lorem ipsum dolor sit amet ?_'+expandQues)" (closed)="onCollapse('Lorem ipsum dolor sit amet ?_'+collapseQues)">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Lorem ipsum dolor sit amet ? </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="mat-panel-body-custom ng-star-inserted">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate risus mattis ornare at egestas tortor.
                      </p>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
